module.exports = __webpack_public_path__ + "img/cattunnel25.7c57008b.jpg";